import { useTheme } from "app/ThemeProvider";
import { ThemeSettingsValue } from "components/themeSettingsModal/themeSettingsUtils";
import React from "react";

export const useDisplayThemeOverride = (
  themeSettings: ThemeSettingsValue | null,
) => {
  const { setThemeOverride, clearThemeOverride } = useTheme();

  React.useEffect(() => {
    if (themeSettings) {
      setThemeOverride(themeSettings);
    } else {
      clearThemeOverride();
    }

    return () => {
      clearThemeOverride();
    };
  }, [clearThemeOverride, setThemeOverride, themeSettings]);
};
